import { ResponseData } from '../../useAlertBanner/useAlertBannerData';

export const formatResponseDataToTaskBannerEligibility = (
  data: ResponseData
) => {
  const { currentAccount } = data;

  const taskBufferOverride = currentAccount.taskBufferOverride;

  const planHasMeteredBilling =
    currentAccount.plan.meteredPricingTiers?.length > 0;

  // metered billing status of an account is determined by both an account setting via entitlement and a plan setting via metered pricing tiers
  const accountHasMeteredBilling = Boolean(
    currentAccount.entitlements?.limits.payPerTaskEnabled &&
      planHasMeteredBilling
  );

  const accountConsumedTasks =
    currentAccount.entitlements?.quotas?.tasks?.count || 0;

  const meteredPricingTaskLimit =
    currentAccount.plan?.meteredPricingTiers?.find(
      (tier) => tier.pricePerTask === 0
    )?.numTasks || 0;

  const nonMeteredPricingTaskLimit =
    currentAccount.entitlements?.quotas?.tasks?.limit || 0;

  const includedTasksPerMonth = planHasMeteredBilling
    ? meteredPricingTaskLimit
    : nonMeteredPricingTaskLimit;

  return {
    accountHasMeteredBilling,
    includedTasksPerMonth,
    accountConsumedTasks,
    taskBufferOverride,
  };
};
